var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vue-simple-spinner",style:(_vm.spinner_style)}),_vm._v(" "),(_vm.message.length > 0)?_c('div',{staticClass:"vue-simple-spinner-text",style:(_vm.text_style)},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eef50984","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = YE1D
// module chunks = 0